import React from 'react';
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Button,
	Row,
	Col,
} from 'reactstrap';
import moment from 'moment';
import PropTypes from 'prop-types';

import { symbolPriceFormatter } from '~/helpers/price';
import { Text } from '~/components/Text';
import { StatusVenda } from '~/components/Status';
import { Cartoes } from '~/components/Cartoes';
import { color } from '~/assets/styles/colors';

export function ModalDetalheVenda(props) {
	const { isOpen, toggle, venda } = props;

	function retornaModalidade(modalidade, parcela) {
		if (modalidade === 'crédito parcelado') {
			return `Parcelado em ${parcela}x`;
		}
		if (modalidade === 'crédito à vista') {
			return `Crédito à vista`;
		}
		if (modalidade === 'débito') {
			return `Débito`;
		}
		return modalidade;
	}

	return (
		<Modal isOpen={isOpen} toggle={toggle}>
			<ModalHeader>
				<Text color="primary" size="big" weight="bold">
					{venda.razao_nome}
				</Text>
			</ModalHeader>
			<ModalBody>
				<Row
					className="pb-3"
					style={{ borderBottom: `1px solid ${color.primary}` }}>
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							ID:
						</Text>
						<Text color="gray">{venda.id}</Text>
					</Col>
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Valor:
						</Text>
						<Text color="gray">
							{symbolPriceFormatter(venda.value)}
						</Text>
					</Col>
				</Row>

				<Row
					className="py-4"
					style={{ borderBottom: `1px solid ${color.primary}` }}>
					<Col className="d-flex align-items-center">
						<Cartoes cartao={venda.brand} />
						<Text color="gray" className="ml-2">
							{retornaModalidade(venda.product, venda.parcels)}
						</Text>
					</Col>
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Status:
						</Text>
						<StatusVenda status={venda.status} />
					</Col>
				</Row>

				<Row className="pt-3">
					<Col className="d-flex align-items-center">
						<Text weight="bold" color="black" className="mr-2">
							Data:
						</Text>
						<Text color="gray">
							{moment(venda.payment_date).format('DD/MM/YYYY')}
						</Text>
					</Col>
				</Row>
			</ModalBody>
			<ModalFooter>
				<Button color="primary" onClick={toggle}>
					Ok
				</Button>
			</ModalFooter>
		</Modal>
	);
}

ModalDetalheVenda.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	toggle: PropTypes.func.isRequired,
	venda: PropTypes.oneOfType([PropTypes.object]),
};

ModalDetalheVenda.defaultProps = {
	venda: {},
};
